import {Simplex as BaseSimplex} from 'services/sports/default/simplex';
import Action from 'actions';
import RuleBuilder from 'services/simplex/rule-builder';
import {getSimplexUnitName} from 'helpers/simplex-helper';
import {groupObjectsByProp} from 'helpers/array-helper';
import Const from 'constants';

export default class SimplexClassic extends BaseSimplex {
    limitPositions({incomingValues = {}}) {
        const {
            sportConfig,
            playersData: {preparedPlayers},
        } = Action.getState();
        const players = preparedPlayers.groupedBy.allowedPositions();
        const maxSingleTeamPlayers = sportConfig.getConfigProp('maxSingleTeamPlayers');

        const teams = groupObjectsByProp(players, 'team');

        const result = [];
        if (maxSingleTeamPlayers) {
            Object.keys(teams).map((teamName) => {
                const ruleBuilder = RuleBuilder.fromAtMost(maxSingleTeamPlayers);

                teams[teamName].map((player) => ruleBuilder.addVar(getSimplexUnitName(player.uniqueId), 1));

                ruleBuilder.isRuleCreatable() && result.push(ruleBuilder.createRule());
            });
        }

        return result;
    }

    subjectToPermanent() {
        const constraints = {
            player: this.exec('player', {}, []),
            salary: this.exec('salary', {}, []),
            projectedOwnershipCap: this.exec('projectedOwnership', {}, []),
            positions: this.exec('positions', {}, []),
            teams: this.exec('team', {}, []),
            limitPositions: this.exec('limitPositions', {}, []),
            projectionBoostRule: this.exec('projectionBoostRule', {}, []),
            bound: this.exec('bound', {}, []),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            createdLineups: this.exec('createdLineups', {}, []),
            nhlTeamStacking: this.exec('nhlTeamStacking', {}, []),
            nhlLegacyTeamStacking: this.exec('nhlLegacyTeamStacking', {}, ''),
            nhlNameStacking: this.exec('nhlNameStacking', {}, []),
            nhlNonControlledStacks: this.exec('nhlNonControlledStacking', {}, []),
            exposureMax: this.exec('exposureMax', {}, []),
            exposureMin: this.exec('exposureMin', {}, []),
            flexExposureMax: this.exec(
                'flexMaxExposure',
                {
                    flexPositionsQuantity: 2,
                },
                [],
            ),
            teamExposureMax: this.exec(
                'teamExposureMax',
                {
                    minPlayersQuantityToIdentifyUsedTeam: Const.NHL_MIN_PLAYERS_QUANTITY_TO_IDENTIFY_USED_TEAM,
                },
                [],
            ),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, []),
        };

        return {...constraints};
    }
}
